import React, { FC } from 'react';
import { TextField } from '@mui/material';
import { capitalize } from 'lodash';
import { ApplicationManagement } from '../../../reduxState/store/applicationManagement/types';
import { AppDefaultCountry } from './AppDefaultCountry';
import { AppServiceableCountries } from './AppServiceableCountries';

export interface AppReadOnlySettingsProps {
  applicationId: string;
  applicationManagement: ApplicationManagement | null;
}

export const AppReadOnlySettings: FC<React.PropsWithChildren<AppReadOnlySettingsProps>> = ({
  applicationId,
  applicationManagement,
}) => {
  const getSplitPolicyValue = (): string => {
    let policyValue = 'Policy Details not found';
    const splits = applicationManagement?.Policy?.Splits;

    if (splits) {
      policyValue = applicationManagement?.Policy.Name + ' - ';
      policyValue += splits.map(s => `${capitalize(s.Part)} ${s.Percentage}`).join(' / ');
    }

    return policyValue;
  };

  return (
    <>
      <AppDefaultCountry
        applicationId={applicationId}
        Country={applicationManagement?.Country || ''}
        applicationManagement={applicationManagement}
      />
      <TextField
        id="defaultCurrency"
        className="settings-form-group"
        label="Default Currency"
        value={applicationManagement?.Currency || ''}
        disabled
        variant="outlined"
        InputLabelProps={{ shrink: true }}
      />
      <AppServiceableCountries
        applicationId={applicationId}
        ServiceableCountries={applicationManagement?.ServiceableCountries || []}
        applicationManagement={applicationManagement}
      />
      <TextField
        id="splitPolicy"
        className="settings-form-group"
        label={`Split Policy`}
        value={getSplitPolicyValue()}
        disabled
        variant="outlined"
        InputLabelProps={{ shrink: true }}
      />
    </>
  );
};
